import { pdf } from '@react-pdf/renderer';

export const downloadPDF = async (doc, title) => {
  const pdfBlob = await pdf(doc).toBlob();
  const pdfUrl = URL.createObjectURL(pdfBlob);
  const downloadLink = document.createElement('a');
  downloadLink.href = pdfUrl;
  downloadLink.download = `${title}`;
  document.body.appendChild(downloadLink);
  downloadLink.click();
  URL.revokeObjectURL(pdfUrl);
  downloadLink.remove();
};
